import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(
    private toastController: ToastController,
    private router: Router) {}

  async showToast(message: string, color: string, duration: number = 2500) {
    const toast = await this.toastController.create({
      message: message,
      duration: duration,
      color: color,
      position: 'bottom', 
      cssClass: 'custom-toast' // This is a custom class I added to the global.scss file
    });
    toast.present();
  }

  async showToastWithJobLink(message: string, color: string, jobId: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3500,
      position: 'top',
      color: color,
      buttons: [
        {
          text: 'View Job',
          role: 'cancel',
          handler: () => {
            this.router.navigate(['/t/jobs/view', jobId]);
          }
        }
      ]
    });
    toast.present();
  }

  async showToastWithContactLink(message: string, color: string, contactId: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: 'top',
      color: color,
      buttons: [
        {
          text: 'View Contact',
          role: 'cancel',
          handler: () => {
            this.router.navigate(['/t/contacts/view', contactId]);
          }
        }
      ]
    });
    toast.present();
  }
  
}
